import { ReactNode, lazy, Suspense } from "react";
import Navbar from "./Navbar";

// Lazy load Footer to reduce initial bundle size
const Footer = lazy(() => import("./Footer"));

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>{children}</main>
      <Suspense fallback={<div className="h-96 bg-background" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Layout;
